import {trackAuthentication} from '@aboutyou/legacy-tracking-sdk';
import type {AuthMedium} from '@aboutyou/user';
import {resetCustomerDataOnceGuard} from '../utils/trackCustomerDataOnce';
import {useTracking} from '../utils/utils';

export const useTrackAuthentication = () => {
  const {TrackingClient, pageContextCallback} = useTracking();
  return (data: {
    action: 'successful' | 'error';
    email?: string;
    customer_id?: string;
    label: AuthMedium;
    type: 'login' | 'sign_up';
  }) => {
    const {action, email, customer_id, label, type} = data;

    TrackingClient.track(
      trackAuthentication({
        type,
        action,
        page: pageContextCallback(),
        label,
        email,
        customer_id,
      }),
    );

    if (action === 'successful') {
      resetCustomerDataOnceGuard();
    }
  };
};
